export class NotImplementedError extends Error {
    constructor(message?) {
        super(message);
        this.message = message;
        this.name = 'NotImplementedError';
    }
}